import React from 'react'

import { arrayOf, shape, string } from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

function TagLinkRow({ label, links = EMPTY_ARRAY }) {
  if (links.length === 0) {
    return null
  }

  return (
    <div className="tag-link-row">
      <span className="tag-link-row__label cgt-body-base-semibold">{label}</span>
      <ul className="tag-link-row__links">
        {links.map(link => (
          <li className="tag-link-row__item" key={link.url}>
            <a className="tag-link-row__link cgt-link-primary-accented" href={link.url}>
              {link.anchor}
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}

TagLinkRow.propTypes = {
  label: string.isRequired,
  links: arrayOf(shape({
    anchor: string.isRequired,
    url: string.isRequired,
  })),
}

export default TagLinkRow
